/**
* 直播间的分享
*/
<template>
	<div style="max-width: 400px; margin: 0 auto;">

		<!-- 打开QIUI 没有打开成功 就跳转其他页面 -->
		<van-overlay :show="loading" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000002') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>


		<!-- 打开QIUI -->
		<div class="open-qiui-div-bg-community_toys" @click="openQIUI">
			<div class="open-qiui-div-button-community_toys">
				<img style="width: 30px; height: 30px;" src="../assets/main03_sys.jpg">
				<span class="open-qiui-div-span-community_toys">{{ $t('language000079') }}</span>
				<img style="width: 13px; height: 13px;" src="../assets/right_grey.png" />
			</div>
		</div>

		<div style="position: relative;">

			<img style="width: 100%; height: auto; max-height: 800px; position: absolute; top: 0; left: 0; z-index: 1;"
				:src="image" fit="fit" />

			<div>
				<span style="background-color: #F33573; padding-left: 10px; padding-right: 10px; padding-top: 5px;
	padding-bottom: 5px; display: inline-block; font-size: 10px; color: white; margin-left: 10px;
	 margin-top: 10px; position: relative; z-index: 2; border-radius: 10px;">{{  $t('language000080') }}</span>
			</div>

			<div>
				<span style=" padding-left: 5px; padding-right: 5px; 
	    display: inline-block; font-size: 18px; color: white; margin-left: 10px;
		 margin-top: 10px; position: relative; z-index: 2; font-weight: bold;">{{ name }}</span>
			</div>

			<div>
				<span style="padding-left: 5px;padding-left: 10px; padding-right: 10px; padding-top: 5px;
	padding-bottom: 5px;
					    display: inline-block; font-size: 14px; color: white; margin-left: 10px;
					    margin-top: 10px; position: relative; z-index: 2; 
					    background-color: rgba(0, 0, 0, 0.3); border-radius: 10px;">{{  $t('language000081') }}</span>

			</div>


		</div>




	</div>
</template>

<script>
	//执行顺序是beforeCreate -> created -> beforeMount -> mounted
	import axios from 'axios';

	import 'vant/lib/index.css'; //导入样式
	import Vue from 'vue';

	import ElementUI from 'element-ui'; // 在Vue实例创建之前引入Element UI库
	import 'element-ui/lib/theme-chalk/index.css';
	Vue.use(ElementUI);

	export default {
		computed: {},
		mounted() {
			// 在生命周期钩子中获取路由参数
			this.image = this.$p_urlImage + "/image/" + this.$route.params.image + ".png";
			this.name = this.$route.params.name;

			console.log("封面地址：", this.image)

			const userLanguage = navigator.language || navigator.userLanguage;
			const isLanguageSupported = this.$p_languages.includes(userLanguage);
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage;
			this.fetchData();
		},
		data() {
			return {
				loading: false, // 是否显示加载效果 （打开qiui）
				loadingData: false, // 是否显示加载效果 (加载数据)
				image: null, //路由参数1
				name: null, //路由参数2
			}
		},
		methods: {
			fetchData() {

				this.image = this.$p_urlImage + "/image/" + this.$route.params.image + ".png";
				this.name = "@" + this.name;

			},
			openQIUI() { // 在这里可以添加打开 QIUI 的逻辑
				const a = document.createElement("a");
				a.href = this.$p_urlScheme + "HomeActivity";

				this.loading = true; //显示加载中
				const u = navigator.userAgent;
				const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
				if (isiOS) { //IOS
					window.location.href = this.$p_urlScheme + "HomeActivity"; // ios对应的app协议
					setTimeout(() => {
						this.loading = false;
						//检测页面是否隐藏，通常用于判断用户是否切换到其他应用或标签。
						let hidden = window.document.hidden || window.document.mozHidden || window.document
							.msHidden || window.document.webkitHidden
						//如果页面未隐藏，表示用户留在当前页面。
						if (typeof hidden == "undefined" || hidden == false) {
							//跳转到下载页面
							this.$router.push({
								name: 'download'
							});
						}
					}, 3000); //延迟3秒执行
				} else { //Android
					window.location.href = this.$p_urlScheme + "HomeActivity"; // 安卓对应的app协议
					setTimeout(() => {
						let hidden = window.document.hidden || window.document.mozHidden || window.document
							.msHidden || window.document.webkitHidden
						if (typeof hidden == "undefined" || hidden == false) {
							this.loading = false;
							//跳转到下载页面
							this.$router.push({
								name: 'download'
							});

						}
					}, 3000); //延迟3秒执行
				}
			},
			//.....
		}
	}
</script>

<style>
</style>